import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { toTitleCase } from '@hiredigital/lib/helpers/utils';
import Styles from './Priorities.module.scss';

const Priorities = ({
  className,
  searchTerm,
  data,
  isEnterprise,
  shouldTruncate,
  showCategory = false,
}) => {
  const [prioritiesList, setPrioritiesList] = useState();

  useEffect(() => {
    showPriorities();
  }, [searchTerm]);

  const showPriorities = () => {
    const items = [];

    data?.map((section, idx) => {
      const subTalentTypes = section.subTalentTypes.filter((p) => {
        if (!searchTerm) return true;
        return p.talentType.toLowerCase().includes(searchTerm.toLowerCase());
      });

      return subTalentTypes.length
        ? section.type === 'StandardTalentDirectory'
          ? items.push(
              <div key={idx}>
                <div className={classNames(Styles.standardList, Styles.hideOverflow)}>
                  {subTalentTypes.map((priority, i) => {
                    return (
                      <a key={i} className={classNames(Styles.standardItem)} href={priority.slug}>
                        {toTitleCase(
                          showCategory
                            ? priority.category || priority.talentType
                            : priority.talentType
                        )}
                      </a>
                    );
                  })}
                </div>
              </div>
            )
          : // SubTalentTypeGroup
            items.push(
              <div key={idx} className={classNames(Styles.section)}>
                <div className={Styles.title}>{section.title}</div>
                <div className={Styles.list}>
                  {subTalentTypes.map((priority, i) => {
                    return (
                      <a key={i} className={classNames(Styles.item)} href={priority.slug}>
                        {toTitleCase(
                          showCategory
                            ? priority.category || priority.talentType
                            : priority.talentType
                        )}
                      </a>
                    );
                  })}
                </div>
              </div>
            )
        : '';
    });
    setPrioritiesList(items);
  };

  if (!prioritiesList && data?.length) {
    showPriorities();
  }

  return (
    <div
      className={classNames(
        data?.length == 1 ? Styles.singleContainer : Styles.container,
        className,
        isEnterprise && Styles.darkMode
      )}>
      {prioritiesList}
    </div>
  );
};

export default Priorities;
